import type { Section } from '@/hooks/useBreadCrumb';
import { MAINTAIN_RIGHTS, MAINTENANCE_RIGHTS } from '@/permissions/route-rights';
import { DUE_SOON_PARAM, OVERDUE_PARAM } from '@pages/MaintenancePage/taskFilters';

export const SCHEDULE_ROUTE = '/maintain/schedule';
// Each list lands pre-filtered on the same predicate this page counts with
// (isTaskExpired / isTaskDueSoon), so a tile's number and the rows behind it agree.
export const OVERDUE_ROUTE = `${SCHEDULE_ROUTE}?${OVERDUE_PARAM}=1`;
export const DUE_SOON_ROUTE = `${SCHEDULE_ROUTE}?${DUE_SOON_PARAM}=1`;

/** Absolute route, for flows outside Maintain that hand off to the history list. */
export const SERVICE_HISTORY_ROUTE = '/maintain/service-history';

/**
 * One row of that list, opened: the task with the invoice, the transaction and the
 * comments filed against it. A record is a task, so the id here is a task id — the
 * same one the list's rows and the equipment page's history table carry.
 */
export const serviceHistoryPath = (taskId: string): string => `${SERVICE_HISTORY_ROUTE}/${taskId}`;

/** Same contract as Manage's: the rights each section's route guard opens on, any-of. */
export const SECTIONS: Section[] = [
  { path: '/', label: 'Maintain', anyOf: MAINTAIN_RIGHTS },
  { path: 'schedule', label: 'Schedule', anyOf: MAINTENANCE_RIGHTS },
  { path: 'service-history', label: 'Service History', anyOf: MAINTENANCE_RIGHTS },
];
